<template>
  <canvas :id="id"></canvas>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    slices: {
      type: Array,
      required: true
    },
    colors: {
      type: String,
      default: "skyblue,teal,lightcyan,lightgreen,lime"
    },
    labels: {
      type: Array,
      required: true
    }
  },
  computed: {
    sum() {
      let component = this;
      let s = 0;
      component.slices.forEach(slice => {
        s += slice;
      });
      return s;
    }
  },
  methods: {
    draw() {
      let component = this;
      let canvas = document.getElementById(component.id);
      let context = canvas.getContext("2d");
      let chart = new Chart(context, {
        type: "pie",
        data: {
          labels: component.labels,
          datasets: [
            {
              label: "Number of Moons",
              data: component.slices,
              backgroundColor: component.colors.split(","),
              borderWidth: 3
            }
          ]
        }
      });
      console.log(chart);
    }
  },
  mounted() {
    let component = this;
    component.draw();
  }
};
</script>
<style lang="scss" scoped>
canvas {
  outline: 1px dashed skyblue;
}
</style>
